export const replaceAt = (text: string, index: number, replacement: string): string => {
  return text.substring(0, index) + replacement + text.substring(index + replacement.length);
};

export const isDefined = <T>(value: T): value is Exclude<T, null | undefined> => {
  return value != null;
};

export const isTruthy = <T>(value: T): value is Exclude<T, null | undefined | '' | false | 0> => {
  return Boolean(value);
};

export const wait = (ms: number): Promise<void> => {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
};
